// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=\"text\"] {\n  transition: all 0.3s ease;\n}", ""]);
// Exports
module.exports = exports;
